import tw from "twin.macro";

export const tabsCss = tw`flex items-center self-baseline`;
